const getServiceLink = (service) => `services/smart-${service}`;

export { getServiceLink };
